import { environment } from '~environments/environment';

export default function isBulgaria(): boolean {
  return Object.keys(environment.applications.phrase.locales).includes('bg-BG');
}
